// extracted by mini-css-extract-plugin
module.exports = {"base":"SearchCriteria_base__3wPfy","remove":"SearchCriteria_remove__eYJD6"};